import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import {Divider, Spin, Grid, Button} from 'antd';
import {getSecurityTeamDetail} from '../../../api/Team';
import {useQuery} from "react-query";
import {useMemo, useState} from "react";
import {TeamLogo} from "./TeamLogo";
import MarkdownIt from "markdown-it";
import {Tabs} from "../../../components/Tabs";
import {Members} from "./Members";
import {useSelector} from "react-redux";
import {currentUser} from "../../../features/user/userSlice";
import {Apply} from "./Apply";
import {getPersonalInfo} from "../../../api/User";

const mdParser = new MarkdownIt();
const {useBreakpoint} = Grid

const CoverBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 229px;
  @media screen and (max-width: 768px) {
    height: 118px;
  }
  background-image: url(${({cover}) => cover});
  background-size: cover;
  background-position: center;
`

const Loading = styled.div`
  text-align: center;
`

const Content = styled.div`
  background: #0E0E0E;
  border-radius: 5px;
  margin-top: 148px;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  padding: 33px 47px;
  @media screen and (max-width: 768px) {
    margin-top: 57px;
    padding: 26px 22px;
  }
`

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 24px;
  margin-left: 23px;
  flex: 1;
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
  > div {
    font-weight: normal;
    font-size: 14px;
    margin-top: 5px;
    @media screen and (max-width: 768px) {
      color: #4B555E;
      font-size: 12px;
      line-height: 15px;
    }
  }
`

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
`

const Desc = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 24px;
`

const TabContent = styled.div`
  position: relative;
`

const TotalScore = styled.div`
  position: absolute;
  top: 12px;
  right: 0;
  font-size: 14px;
  color: #00eec2;
  font-weight: bold;
`

export const SecurityTeamDetail = () => {
    const { title } = useParams();

    const breakpoint = useBreakpoint();

    const isMobile = useMemo(() => {
        return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
    }, [breakpoint])
    const user = useSelector(currentUser);
    const {data, isLoading} = useQuery(['team-detail', title], () => getSecurityTeamDetail(title))
    const {data: userInfo} = useQuery('userinfo', () => getPersonalInfo(), {
        enabled: !!user.token && user.user.type === 0
    })

    const userMemberStatus = useMemo(() => {
        const status = userInfo?.data.member_status
        return status ? +status : 0
    }, [userInfo])

    const detail = useMemo(() => {
        return data?.data ?? {}
    }, [data])

    if (isLoading) return (
        <Loading>
            <Spin spinning />
        </Loading>
    )

    const tabItems = [{
        label: 'Detail',
        key: '1',
        children: (
            <Desc>
                <div className='custom-html-style' dangerouslySetInnerHTML={{__html: mdParser.render(detail.description)}} />
            </Desc>
        )
    }, {
        label: 'Members',
        key: '2',
        children: (
            <Members />
        )
    }]

    return (
        <>
            <CoverBg cover={detail.cover_file} />
            <Content>
                <TitleWrap>
                    <TeamLogo size={isMobile ? 64 : 89} logo={detail.logo_file} />
                    <Title>
                        {detail.title}
                        <div>{detail.summary}</div>
                    </Title>
                    <Apply userMemberStatus={userMemberStatus} team={data.data} />
                </TitleWrap>
                <Divider />
                <TabContent>
                    <TotalScore>
                        Total Score: {detail.total_score ?? 0}
                    </TotalScore>
                    <Tabs items={tabItems} />
                </TabContent>
            </Content>
        </>
    );
};
